// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--96b46";
export var thumbsSwiper = "index-module--thumbs-swiper--77192";